import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import VoiceFileResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/VoiceFileResponse";
import AffirmationUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationUpdateRequest";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";
import AffirmationGetDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationGetDetailResponse";
import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import MeditationTranslateViewModel from "@models/meditations/create/meditationTranslateViewModel";
import MeditationAudioViewModel from "@models/meditations/create/meditationAudioViewModel";

export default class CreateAffirmationViewModel {
    id?: number = null;
	isPaid: boolean = false;
	useBackgroundMusic: boolean = true;
	animationId: string = null;
	animationUrl: string = '';
	audios: Array<AudioGroupViewModel> = [];
	translations: Array<MeditationTranslateViewModel> = null; // 
	iconImage: ImagePreviewModel = new ImagePreviewModel();
	coverImage: ImagePreviewModel = new ImagePreviewModel();
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	initLanguages(languages: string[]) {
		this.translations = languages.map(
			(x) =>
			  new MeditationTranslateViewModel({
				langCode: x,
			  })
		  );
	}
	toServerModel(): AffirmationUpdateRequest {
		const req = new AffirmationUpdateRequest({
			Id: this.id,
			IsPaid: this.isPaid,
			UseBackgroundMusic: this.useBackgroundMusic,
			AnimationId: this.animationId,
			Back: mapToCropRequest(this.backgroundImage), // this.coverImage,
			Cover: mapToCropRequest(this.coverImage), // this.coverImage,
			Icon: mapToCropRequest(this.iconImage), // this.iconImage,
			Translations: this.translations.map(x=>x.toServerModel())
		});
		this.audios.forEach(audioGroup => {
			req.Translations.forEach(tr => {
				if (!tr.VoiceFiles) {
					tr.VoiceFiles = [];
				}
				const audios = audioGroup.audios.filter(x=>x.langCode == tr.LangCode);
				if (audios.length > 0) {
					tr.VoiceFiles.push(...(audios.map(a=>a.toServerModel())));
				}
			});
		});
		return req;
	}
	fromServerModel(model: AffirmationGetDetailResponse) {
		this.id = model.Id;
		this.isPaid = model.IsPaid;
		this.useBackgroundMusic = model.UseBackgroundMusic;
		this.animationId = model.AnimationId;

		const langs = this.translations.map(x => x.langCode);
		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.name = serverTranslation.Name;
				tr.description = serverTranslation.Description;
			}
		});
		const counts = model.Translations.map(x=>(x.VoiceFiles || []).length || 0);
		const audioCount = Math.max(...counts);
		this.backgroundImage.ImageUrl = model.BackUrl;
		this.coverImage.ImageUrl = model.CoverUrl;
		this.iconImage.ImageUrl = model.IconUrl;
		this.audios = Array(audioCount).fill(0).map(x=> new AudioGroupViewModel(langs));
		this.audios.forEach((audioGroup, i) => {
			audioGroup.audios = [];
			const audios = this.translations.map(x=>{
					const voiceFiles = ((model.Translations.find(mt => mt.LangCode == x.langCode) || {}).VoiceFiles || [])
					return {
						langCode: x.langCode,
						file: ((voiceFiles || [])[i] || new VoiceFileResponse({Url: null}))
				}
			}).filter(x=>x.file!=null);
			if (audios != null && audios.length > 0) {
				audioGroup.audios = audios.map(x=> new MeditationAudioViewModel({
					id: x.file.Id,
					langCode: x.langCode,
					name: x.file.Name,
					description: x.file.Description,
					isPaid: x.file.IsPaid,
					audioUrl: x.file.Url
				}));
			}
		});
	}
}
